import { OldProductSpecIterator } from "./old/OldProductSpecIterator";
import { VueProductSpecIterator } from "./vue/VueProductSpecIterator";

export function getSpecIterators() {
    return [new OldProductSpecIterator(), new VueProductSpecIterator()];
}
